import React, { useState, useEffect, useRef} from "react";
import './Settings.css';
import ArtistProfilePic from './../../../images/artistprofilepic.png'
import NervousLogo from './../../../images/nervouslogo.png'

import NerveProLogo from './../../../images/nerveprologo.png'
import InviteOnlyLogo from './../../../images/inviteonlylogo.png'
import WarningIcon from './../../../images/warningicon.png'
import ArtistNameSubmitted from './../../../images/artistnamesubmitted.png'
import DisclaimerPopup from './../../../images/settingsdisclaimericon.png'
import PeggyGouSpotify from './../../../images/peggygouspotify.png'
import DrakeSpotify from './../../../images/drakespotify.png'
import Cookies from 'universal-cookie';

import PeggyGouApple from './../../../images/peggygouapplemusic.png'
import CrossIcon from './../../../images/crossicon.png'
import ArrowDown from './../../../images/arrowdown.png'
import profilepicempty from './../../../images/profilepicempty.png'

import Select from 'react-select'

import { Country, State, City }  from 'country-state-city';
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"

import ReactModal from 'react-modal';
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import axios from "axios"; 
import { useJwt, decodeToken } from "react-jwt";



import {Route,Routes, Redirect, Navigate} from 'react-router-dom'
import ArtistSettings from "./../../PostLogin/Dashboard/Settings/ArtistSettings";
import AccountSettings from "./../../PostLogin/Dashboard/Settings/AccountSettings";
import SecuritySettings from "./../../PostLogin/Dashboard/Settings/SecuritySettings";
import WalletSettings from "./../../PostLogin/Dashboard/Settings/WalletSettings";
import NotificationSettings from "./../../PostLogin/Dashboard/Settings/NotificationSettings";
import DeleteSettings from "./../../PostLogin/Dashboard/Settings/DeleteSettings";
import ChangePlan from "./../../PostLogin/Dashboard/Settings/ChangePlan";
import ArtistName from "./../../PostLogin/Dashboard/Settings/ArtistNamePages/ArtistName";
import { useNavigate,useLocation } from "react-router-dom";
 

function Settings({nav,hidedashboard}) {
    const [option,setOption] = useState(1);
    const [city,setCity] = useState()  
    const [recoveryCode, setrecoveryCode] = useState();
    const [email,setEmail] = useState()
    const cookies = new Cookies(null ,{ path: '/' });
    const [password,setPassword] = useState()
    const [newpassword,setNewPassword] = useState()
    const [newpassword2,setNewPassword2] = useState()
    const [viewSettings,setViewSettings] = useState(false)
    const [viewTaskbar,setViewTaskbar] = useState(true)
    const location = useLocation();
    
   
    const [profileLink,setProfileLink] = useState("")
    
    const [viewSelectPlan,setViewSelectPlan] = useState(false)
    
    const {t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [disclaimer,setDisclaimer] = useState("")
    



    const toogleTaskbar = (data)=>{
        setViewTaskbar(data)
    }

    const toogleOption = (data) =>{
        setOption(data)
    }
   
    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth
      })

      function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    
    useEffect(()=>{
        topFunction()
        nav("Settings")
        hidedashboard(true)
    },[])

    useEffect(()=>{
        if(cookies.get("artistname").length!==0){
            setViewSettings(true)
        }else{
            setViewSettings(true)
            navigate("/dashboard/label/settings/artistname")
        }
      },[])

    useEffect(()=>{
        console.log(location.pathname)
        if(location.pathname === "/dashboard/label/settings/changeplan" )
        {
            hidedashboard(false)
            toogleTaskbar(false)
        }else if(location.pathname === "/dashboard/label/settings/artistname"){
            toogleTaskbar(false)
        }else{
            hidedashboard(true)
            toogleTaskbar(true)
        }
      },[location.pathname])

   
    
      useEffect(() => {
        function handleResize() {
          setDimensions({
            height: window.innerHeight,
            width: window.innerWidth
          })
        
    }
    
        window.addEventListener('resize', handleResize)
    
        return _ => { 
          window.removeEventListener('resize', handleResize)
        }
      })

    

    return (
        <div className="SettingsContainer" style={{display:'flex',justifyContent:'left',height:'100vh',overflowY:'scroll'}}>
    
           
            {
                viewSettings && viewTaskbar &&
                <div className="SettingsContainer" style={{height:dimensions.height,width:'100%'}} >
                <div className="SettingsHeader">
                     {t('Settingsheader')}
                </div>
    
                <div style={{display:'flex',flexDirection:'row', borderBottom:'1px #595959 solid',marginLeft:'2.5em',width:'93.28%'}}>
                    {
                       option !== 1 &&
                        <div>
                            <div className="SettingDrawerHeading" onClick={()=>{setOption(1);navigate("/dashboard/label/settings")}} style={{cursor:'pointer'}}>{t('artist')}</div>
                        </div>
                    }
    
                    {
                       option === 1 &&
                        <div >
                            <div className="SettingDrawerHeadingSelected">{t('artist')}</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                    {
                       option !== 2 &&
                        <div>
                            <div className="SettingDrawerHeading" onClick={()=>{setOption(2);navigate("/dashboard/label/settings/accsettings")}} style={{cursor:'pointer'}}>{t('account')}</div>
                        </div>
                    }
    
                    {
                       option === 2 &&
                        <div>
                            <div className="SettingDrawerHeadingSelected">{t('account')}</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                    {
                       option !== 3 &&
                        <div>
                            <div className="SettingDrawerHeading" onClick={()=>{setOption(3);navigate("/dashboard/label/settings/secsettings")}} style={{cursor:'pointer'}}>SECURITY</div>
                        </div>
                    }
    
                    {
                       option === 3 &&
                        <div>
                            <div className="SettingDrawerHeadingSelected">SECURITY</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                    {
                       option !== 4 &&
                        <div>
                            <div className="SettingDrawerHeading" onClick={()=>{setOption(4);navigate("/dashboard/label/settings/walletsettings")}} style={{cursor:'pointer'}}>{t('Walletheader')}</div>
                        </div>
                    }
    
                    {
                       option === 4 &&
                        <div>
                            <div className="SettingDrawerHeadingSelected">{t('Walletheader')}</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
    
                    {
                       option !== 5 &&
                        <div>
                            <div className="SettingDrawerHeading" onClick={()=>{setOption(5);navigate("/dashboard/label/settings/notifsettings")}} style={{cursor:'pointer'}}>{t('Notification')}</div>
                        </div>
                    }
    
                    {
                       option === 5 &&
                        <div>
                            <div className="SettingDrawerHeadingSelected">{t('Notification')}</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }

                    {
                       option !== 6 &&
                        <div>
                            <div className="SettingDrawerHeading" onClick={()=>{setOption(6);navigate("/dashboard/label/settings/deletesettings")}} style={{cursor:'pointer'}}>DELETE ACCOUNT</div>
                        </div>
                    }
    
                    {
                       option === 6 &&
                        <div>
                            <div className="SettingDrawerHeadingSelected">DELETE ACCOUNT</div>
                            <div style={{backgroundColor:'#FF6694',height:'1px'}}/>
                        </div>
                    }
            
                </div>
               
                <Routes>
                    <Route exact path="/" element={<ArtistSettings toogleOption={toogleOption}/>}/>
                    <Route exact path="/accsettings" element={<AccountSettings  toogleOption={toogleOption} />}/>
                    <Route exact path="/secsettings" element={<SecuritySettings  toogleOption={toogleOption} />}/>
                    <Route exact path="/walletsettings" element={<WalletSettings  toogleOption={toogleOption} />}/>
                    <Route exact path="/notifsettings" element={<NotificationSettings  toogleOption={toogleOption} />}/>
                    <Route exact path="/deletesettings" element={<DeleteSettings  toogleOption={toogleOption} />}/>
                </Routes>
                

                </div>
            }

            {
                viewSettings && !viewTaskbar &&
                <div className="SettingsContainer" style={{height:dimensions.height,width:'100%'}} >
               
                <Routes>
                    <Route exact path="/changeplan" element={<ChangePlan/>}/>
                    <Route exact path="/artistname" element={<ArtistName/>}/>
                </Routes>
                

                </div>
            }
              
        </div>
       
    );
}

export default Settings;